import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import Link from 'react-router/lib/Link';
import { t } from '../../../infra/i18n';
import ShopType from '../../../../app/admin/shops/components/shopType';
import { ImporsonateValidUser } from '../../../../app/admin/shared/ImpersonateUser';
export var getColumns = function () { return [
    {
        id: 'expander',
        maxSize: 50,
        cell: function (ctx) { return (_jsx("button", { type: "button", className: cx('expander-btn', { 'expander-btn--open': ctx.row.getIsExpanded() }), children: "." })); },
    },
    {
        header: t('admin:users.list.shop_name_header'),
        accessorKey: 'name',
        id: 'name',
    },
    {
        header: t('admin:users.list.shop_type_header'),
        accessorKey: 'kind',
        id: 'kind',
        cell: function (ctx) { return _jsx(ShopType, { type: ctx.getValue() }); },
    },
    {
        header: t('admin:users.list.barbers_header'),
        id: 'barberCount',
        accessorKey: 'barberCount',
        size: 100,
    },
    {
        header: t('admin:users.list.users_count_header'),
        id: 'userCount',
        accessorKey: 'userCount',
        maxSize: 100,
    },
]; };
export var buildShopUsersColumns = function (shop) { return [
    {
        header: t('admin:users.list.username_header'),
        accessorKey: 'username',
        id: 'username',
    },
    {
        header: t('admin:users.list.kind_header'),
        id: 'kind',
        accessorKey: 'userType',
    },
    {
        header: t('admin:users.list.name_header'),
        accessorKey: 'name',
        id: 'name',
    },
    {
        header: t('admin:users.list.actions_header'),
        id: 'actions',
        maxSize: 100,
        accessorFn: function (value) { return value; },
        cell: function (ctx) { return (_jsxs("span", { children: [_jsx(Link, { className: "u-co-primary u-type--bold", to: "/admin/users/".concat(ctx.getValue().userId), children: t('admin:users.list.edit_action') }), _jsx("br", {}), _jsx(ImporsonateValidUser, { id: ctx.getValue().userId, shopId: ctx.getValue().userType === 'brand' ? null : shop.id })] })); },
    },
]; };
